import { render, staticRenderFns } from "./MissedCalls.vue?vue&type=template&id=b1b4e58c&scoped=true"
import script from "./MissedCalls.vue?vue&type=script&lang=js"
export * from "./MissedCalls.vue?vue&type=script&lang=js"
import style0 from "./MissedCalls.vue?vue&type=style&index=0&id=b1b4e58c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b4e58c",
  null
  
)

export default component.exports